module.exports = __webpack_public_path__ + "img/4.4cf26fd2.png";